import { Reveal } from "@/components/Reveal";
import Logo from "./Logo";

const KPIS = [
  ["$7,500", "fixed fee, full scope"],
  ["12 wks", "to go-live, incl. 2 weeks buffer"],
  ["Week 8", "Budget vs Booked live"],
  ["3 \u2192 1", "sources compared on one record"],
];

export default function Hero() {
  return (
    <header className="mx-auto max-w-6xl px-4 sm:px-6 pt-10 pb-6" data-testid="hero-section">
      <Reveal>
        <div className="flex items-center gap-3">
          <Logo className="h-5 w-auto" />
          <span className="font-mono text-[10px] uppercase tracking-[0.12em] text-fog border-l border-hair pl-3" data-testid="header-client-mark">
            <span className="text-coal font-medium mr-1">&times;</span> MMG
          </span>
        </div>
      </Reveal>
      <Reveal delay={0.05}>
        <span className="mt-6 inline-flex items-center font-mono text-[11.5px] tracking-[0.06em] uppercase text-fog border border-hair bg-white rounded px-2 py-0.5">
          Prodigitas &middot; architecture review &amp; estimate
        </span>
      </Reveal>
      <Reveal delay={0.1}>
        <h1 className="mt-5 font-display font-light text-[1.9rem] sm:text-4xl lg:text-[2.9rem] leading-[1.12] tracking-[-0.01em] text-coal max-w-3xl">
          Morgan Murphy Media: budgets, pacing and forecasting in HubSpot
        </h1>
      </Reveal>
      <Reveal delay={0.15}>
        <p className="mt-5 max-w-3xl text-[15px] sm:text-base leading-relaxed text-fog">
          One connected view of budget, booked revenue from WideOrbit and pending
          pipeline, rolling up from AE to market to corporate. Here's how we'd build it,
          what we found in the documents, and what it takes.
        </p>
      </Reveal>
      <Reveal delay={0.2}>
        <div className="mt-8 grid grid-cols-2 lg:grid-cols-4 gap-px bg-hair border border-hair rounded-md overflow-hidden" data-testid="hero-stats">
          {KPIS.map(([v, l]) => (
            <div key={l} className="bg-white px-4 sm:px-5 py-4">
              <p className="font-display text-2xl sm:text-3xl text-coal">{v}</p>
              <p className="mt-1 text-[12.5px] text-fog">{l}</p>
            </div>
          ))}
        </div>
      </Reveal>
    </header>
  );
}
